export const AmexIcon = ({ ...props }) => {
  return (
    <svg
      width="55"
      height="30"
      viewBox="0 0 55 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.22852 0.491211H54.7498V16.1833V18.4032V20.4999V29.5228H1.22852V14.7444V13.8073V12.6888V0.491211Z"
        fill="#016FD0"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M34.2252 4.00977L29.5645 15.5832H34.6622V26.2831H47.8434L48.7901 24.9729L49.8825 26.2831H53.8879V22.9349L51.9944 20.3872L53.8879 18.1308V4.00977H49.2999L48.2804 6.19343L46.8967 4.00977H41.0707V8.59546L38.9588 4.00977H34.2252Z"
        fill="white"
      />
      <path
        d="M35.3188 5.56113L31.3945 14.6863H33.9494L34.6735 12.859H38.8829L39.6032 14.6863H42.2144L38.2937 5.56113H35.3188ZM36.7707 7.68476L38.0537 10.8779H35.4839L36.7707 7.68476ZM42.4845 14.6847V5.55957L46.1151 5.57303L48.2268 11.4564L50.2879 5.55957H53.8895V14.6847H51.6085V7.96094L49.1906 14.6847H47.1901L44.7655 7.96094V14.6847H42.4845Z"
        fill="#016FD0"
      />
      <path
        d="M36.1816 25.0626V15.9375H43.6248V17.9786H38.4866V19.5395H43.5048V21.4606H38.4866V23.0815H43.6248V25.0626H36.1816ZM43.9137 25.0626L47.5379 20.5564L43.8274 15.9375H46.7013L48.911 18.7928L51.1283 15.9375H53.8895L50.2279 20.5L53.8586 25.0626H50.9854L48.8397 22.2523L46.7463 25.0626H43.9137Z"
        fill="#016FD0"
      />
    </svg>
  )
}
